/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "collapse_button_label": [{
    "type": 0,
    "value": "Collapse "
  }, {
    "type": 1,
    "value": "name"
  }, {
    "type": 0,
    "value": " card"
  }],
  "collapse_button_tooltip": [{
    "type": 0,
    "value": "Collapse"
  }],
  "expand_button_label": [{
    "type": 0,
    "value": "Expand "
  }, {
    "type": 1,
    "value": "name"
  }, {
    "type": 0,
    "value": " card"
  }],
  "expand_button_tooltip": [{
    "type": 0,
    "value": "Expand"
  }],
  "mobile_scroll_tracker": [{
    "type": 1,
    "value": "scrolledToCard"
  }, {
    "type": 0,
    "value": " of "
  }, {
    "type": 1,
    "value": "cardCount"
  }],
  "next_scroll_button_label": [{
    "type": 0,
    "value": "Scroll to the next card"
  }],
  "previous_scroll_button_label": [{
    "type": 0,
    "value": "Scroll to the previous card"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var DefaultTranslationComp = Object.assign(TranslationProviderComponent, {
  translations
});

export { DefaultTranslationComp as D };
//# sourceMappingURL=en-US-B70johtp.js.map
